module.exports = __webpack_public_path__ + "static/media/dk.85d27644.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/dk.svg
// module id = 1219
// module chunks = 0